import { defineNuxtPlugin, useHead, useRuntimeConfig } from "#imports";
export default defineNuxtPlugin(() => {
  const { gtag: gtagOpts } = useRuntimeConfig().public;
  if (!gtagOpts.id)
    return;
  window.dataLayer = window.dataLayer || [];
  function gtag(..._args) {
    window.dataLayer.push(arguments);
  }
  gtag("js", /* @__PURE__ */ new Date());
  gtag("config", gtagOpts.id, gtagOpts.config);
  useHead({
    script: [
      {
        src: `https://www.googletagmanager.com/gtag/js?id=${gtagOpts.id}`,
        async: true
      }
    ]
  });
  return {
    provide: {
      gtag
    }
  };
});
